<template>
    <div>
        <Button v-show="isShowAllRead" type="text" style="box-shadow: none;" @click="setAllFileIsRead">全部标记为已读</Button>
        <Table :data="tableData1" height="440" class="tableBorder" :columns="tableColumns1" size="small" :show-header="showheader" stripe></Table>
        <br />
        <Row>
            <Col span="24">
            <Page :total="pageTotal" :page-size="pagesize" :current.sync="pageIndex" @on-change="changePage"></Page>
            </Col>
        </Row>
    </div>
</template>
<script>
export default {
    name: 'NoticeTable',
    // props: { mydata: Object, },
    data() {
        return {
            tableData1: [], //this.mockTableData1(), //tabledata.tabrows,
            tableColumns1: [], //this.mockTableHeader(),
            showHeaders: [],
            pageTotal: 10,
            showheader: false,
            pageIndex: 1,
            pagesize: 10,
            isShowAllRead: false,
            unreadfile: [],
        }
    },
    inject: ['CreatePage', 'getSliders', 'setOneFileIsRead', 'setAllFileIsRead'],
    methods: {
        mockTableData1(tabrows) {
            //console.log(this.mydata)
            let da = [];
            let items = tabrows //this.mydata.tabrows
            if (items && items.length > 0) {
                for (var i = 0; i < items.length; i++) {
                    da.push({
                        fileid: items[i].strdocid,
                        filename: items[i].h1,
                        desc: items[i].changelog,
                        isread: items[i].userread,
                        date: items[i].changedate,
                    })

                    if (!items[i].userread) {
                        this.unreadfile.push(items[i].userread)
                        //this.isShowAllRead = true
                    }
                    if(this.unreadfile.length>0){
                      this.isShowAllRead = true
                    } else{
                       this.isShowAllRead = false
                    }
                }
            }
            //console.log(da)
            return da;
        },
        mockTableHeader(header, headerTitle) {
            var that = this
            let da = [];
            let items = header //this.mydata.header;
            let newHeaders = [];
            this.setHeader(headerTitle)
            for (var i = 0; i < items.length; i++) {
                if (this.showHeaders.indexOf(items[i].key) >= 0) {
                    newHeaders.push(items[i])
                }
            }
            //console.log(newHeaders)
            items = newHeaders;
            // da.push({
            //     type: 'index',
            //     width: 60,
            //     align: 'center'
            // })
            da.push({
                title: '序号',
                align: 'center',
                width: 60,
                sortable: true,
                render: (h, params) => {
                    return h('span', params.index + (this.pageIndex - 1) * this.pagesize + 1)
                }

            })
            for (var i = 0; i < items.length; i++) {
                if (items[i].key == "filename") {
                    da.push({
                        title: items[i].title,
                        key: items[i].key,
                        //width: items[i].width,
                        //align: items[i].align,
                        render: (createElement, params) => {
                            const row = params.row;
                            const text = row.filename;
                            const fileid = row.fileid;
                            const desc = row.desc;
                            const readstr = !row.isread ? '未读' : '';
                            const datestr = row.date
                            return createElement('div', {
                                style: {
                                    color: '#515a6e',
                                    marginTop: '5px',
                                    marginBottom: '5px',
                                }
                            }, [
                                createElement('a', {
                                    domProps: {
                                        innerHTML: `` + text + ``
                                    },
                                    on: {
                                        'click': () => {
                                            row.isread = true
                                            that.add(fileid, 1, text,row);
                                        }
                                    }
                                }, text + " "),
                                ' ',
                                desc,
                                createElement('Tag', {
                                    props: {
                                        color: 'warning',
                                    },
                                    style: {
                                        marginLeft: '20px',
                                        width: '60px',
                                        textAlign: 'center',
                                        display: !row.isread ? 'inline-block' : 'none'
                                    }
                                }, readstr),
                                // createElement('span', {
                                //    domProps:{
                                //     innerHTML:``+readstr+``
                                //   },
                                //   style:{
                                //     color:'red'
                                //   }
                                // }),
                                createElement('p', {
                                    domProps: {
                                        innerHTML: `` + datestr + ``
                                    },
                                    style: {
                                        color: '515a6e'
                                    }
                                }),

                            ]);
                        }
                    })

                } else if (items[i].key == "isread") {
                    // da.push({
                    //   title: items[i].title,
                    //   key: items[i].key,
                    //   //width: items[i].width,
                    //   align: items[i].align,
                    //   render: (h, params) => {
                    //     let color = '';
                    //     let text = '';
                    //     const row = params.row;
                    //     if (!row.isread) {
                    //       color = 'error';
                    //       text = 'New';
                    //       return h('Tag', {
                    //         props: {
                    //           // type: 'null',
                    //           color: color
                    //         }
                    //       }, text);
                    //     } else {
                    //       return h('div', '')
                    //     }



                    //   }
                    // })
                } else {
                    da.push({
                        title: items[i].title,
                        key: items[i].key,
                        // width: items[i].width,
                        //align: items[i].align,
                    })
                }

            }

            return da;
        },
        setHeader(arrayObj) {
            if (arrayObj == null || arrayObj == undefined || arrayObj.length == 0) {
                this.showHeaders = ['fileid', 'filename']
            } else {
                this.showHeaders = arrayObj
            }

        },
        // formatDate (date) {
        //     const y = date.getFullYear();
        //     let m = date.getMonth() + 1;
        //     m = m < 10 ? '0' + m : m;
        //     let d = date.getDate();
        //     d = d < 10 ? ('0' + d) : d;
        //     return y + '-' + m + '-' + d;
        // },
        changePage(index) {
            // The simulated data is changed directly here, and the actual usage scenario should fetch the data from the server
            //this.tableData1 = this.mockTableData1();
            this.$emit('changepage', index,'4')
        },
        add(fid, orderid, filename,row) {
            this.setOneFileIsRead([fid])
            this.CreatePage(fid, orderid, filename,row);
        },
        reloadHeaderData(obj) {
            this.tableColumns1 = this.mockTableHeader(obj);
        },
        show(data) {
            //console.log(data.header)
            // this.classId=data.classid
            this.pageIndex = data.index
            this.tableName = data.tabname
            this.pageTotal = data.total
            this.tableData1 = this.mockTableData1(data.tabrows)
            this.tableColumns1 = this.mockTableHeader(data.header, ['filename'])
            //在路由切换时存在已分屏的情况，在已分屏情况下需要判断是否处于分屏在渲染table的header

            // if (this.sliders.length > 0) {
            //   this.tableColumns1 = this.mockTableHeader(data.header, ['h1'])
            // } else {
            //   this.tableColumns1 = this.mockTableHeader(data.header, '')
            // }

            this.$nextTick(() => {

            })

        },
    },
    watch: {
        sliders: function() {
            if (this.sliders.length == 0) {
                this.reloadHeaderData([]);
            } else if (this.sliders.length > 0) {
                this.reloadHeaderData(['filename']);
            }
        },
    },
}
</script>
<style scoped>
.tableBorder {
    /*border: 1px solid #dcdee2;*/
    border-bottom: none;

}

.tableBorder>.ivu-table>.ivu-table-overflowX {
    overflow-x: hidden;
}
</style>